import React from 'react';
import PropTypes from 'prop-types';
import GenericFormContainer from '../../../helpers/GenericFormContainer';
import {AuthService} from '../../../services/AuthService';

import styles from './ConfirmMail.module.scss';
import AuthGeneric from '../../../components/Auth/layouts/AuthGeneric'
import i18n from 'i18n';


export class ConfirmMailView extends GenericFormContainer {
    componentDidMount(){
        this.handleSubmit();
    }

    resetSent = () => {
        this.setState({
            sent: false
        })
    }

    handleSubmit = () => {
        this.beforeSubmit();
        AuthService.confirm(this.props.match.params.user, this.props.match.params.key
        ).then(data => {
            this.afterSubmit();
            AuthService.loadUser().then(data => {
                this.props.history.push('/admin');
            }).catch(error => {
                this.showError(i18n.t("error.validating.account"));
            });
        }).catch((error) => {
            this.afterSubmit();
            this.dealWithError(error, i18n.t("error.validating.account"));
            this.setState({
                costumMessage: i18n.t("error.validating.account")
            })
        }
        );
    };

    render() {
        const {
            title
        } = this.props;
        const content = <div className={styles['confirm-mail']}>
            <h1>{this.state.costumMessage}</h1>
        </div>

        return (
            <div className={styles['email-verification-container']}>
                <AuthGeneric title={title} version={'header'} content={content}></AuthGeneric>
            </div>
        )
    }

}


ConfirmMailView.propTypes = {
    handleChange: PropTypes.func,
    label: PropTypes.string
};

export default ConfirmMailView;
